$(document).ready(function() {
  $(".product-colors").each(function() {
    var $cardColors = $(this);
    var $cardWrapper = $cardColors.closest(".card-wrapper");
    var $cardImg = $cardWrapper.find(".card__media img.first-image");

    // Initial active swatch
    var $initialActive = $cardColors.find(".color-swatch.active");
    $cardColors.data("clickedSwatch", $initialActive);

    // Set initial image
    var defaultImage = $initialActive.data("variant-image");
    $cardImg.attr("src", defaultImage);
    $cardImg.attr("srcset", defaultImage);
  });

  // Hover in
  $(document).on("mouseenter", ".color-swatch", function() {
    var $this = $(this);
    var $cardColors = $this.closest(".product-colors");
    var $cardWrapper = $cardColors.closest(".card-wrapper");
    var $cardImg = $cardWrapper.find(".card__media img.first-image");

    // Cancel any previous hover-out timeout
    var prevTimeout = $cardColors.data("hoverOutTimeout");
    if (prevTimeout) clearTimeout(prevTimeout);

    // Add hover class
    $cardWrapper.addClass("hovered");
    // $this.addClass("hovered").siblings().removeClass("hovered");

    // Temporarily change active class
    $this.addClass("active").siblings().removeClass("active");

    // Change image
    var imgUrl = $this.data("variant-image");
    $cardImg.attr("src", imgUrl);
    $cardImg.attr("srcset", imgUrl);
  });

  // Hover out
  $(document).on("mouseleave", ".color-swatch", function() {
    var $this = $(this);
    var $cardColors = $this.closest(".product-colors");
    var $cardWrapper = $cardColors.closest(".card-wrapper");
    var $cardImg = $cardWrapper.find(".card__media img.first-image");

    // Remove hover class
    $cardWrapper.removeClass("hovered");
    // $this.removeClass("hovered");

    // Set timeout to revert to clicked swatch
    var timeout = setTimeout(function() {
      var $clicked = $cardColors.data("clickedSwatch");
      $clicked.addClass("active").siblings().removeClass("active");
      
      if($clicked.length > 0){
        var imgUrl = $clicked.data("variant-image");
      }else{
        var imgUrl = $cardColors.data('image');
        $cardColors.find('.color-swatch').removeClass("active")
      }
      $cardImg.attr("src", imgUrl);
      $cardImg.attr("srcset", imgUrl);
    }, 500);

    // Save this timeout so we can cancel if user hovers another swatch
    $cardColors.data("hoverOutTimeout", timeout);
  });

  // Click
  $(document).on("click", ".color-swatch", function() {
    var $this = $(this);
    var $cardColors = $this.closest(".product-colors");
    var $cardWrapper = $cardColors.closest(".card-wrapper");
    var $cardImg = $cardWrapper.find(".card__media img.first-image");

    // Cancel any hover-out timeout
    var prevTimeout = $cardColors.data("hoverOutTimeout");
    if (prevTimeout) clearTimeout(prevTimeout);

    // Update clicked swatch
    $cardColors.data("clickedSwatch", $this);

    // Update active class
    $this.addClass("active").siblings().removeClass("active");

    // Update image
    var imgUrl = $this.data("variant-image");
    $cardImg.attr("src", imgUrl);
    $cardImg.attr("srcset", imgUrl);
  });

  /* ---------- +MORE CLICK ---------- */
  $(document).on("click", ".color-more", function() {
    const $more = $(this);
    const $wrapper = $more.closest(".product-colors");
    $wrapper.addClass("expanded");
    $more.remove();
  });
});

$(document).on("click", ".custom-quick-add__submit", function() {
  setTimeout(function() { 
    $('cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden')
  }, 1000);
});



document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.getElementById("scroll-btn");
  const originalBtnSelector = '#ProductSubmitButton-template--20191939756187__main';

  if (!stickyBtn) return;

  function isVisible(elem) {
    const rect = elem.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function toggleSticky() {
    const originalBtn = document.querySelector(originalBtnSelector);
    if (!originalBtn) return;

    if (isVisible(originalBtn)) {
      stickyBtn.classList.remove("show");
    } else {
      stickyBtn.classList.add("show");
    }
  }

  function waitForOriginal() {
    const originalBtn = document.querySelector(originalBtnSelector);
    if (originalBtn) {
      window.addEventListener("scroll", toggleSticky);
      window.addEventListener("resize", toggleSticky);
      toggleSticky();
    } else {
      setTimeout(waitForOriginal, 300);
    }
  }

  waitForOriginal();

  const observer = new MutationObserver(toggleSticky);
  observer.observe(document.body, { childList: true, subtree: true });

  stickyBtn.addEventListener("click", function () {
    const originalBtn = document.querySelector(originalBtnSelector);
    if (originalBtn) originalBtn.click();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('#menu-drawer');
  if (!drawer) return;

  /**
   * TOP LEVEL
   */
  const topSummaries = drawer.querySelectorAll(
    '.menu-drawer__menu > li > details > summary.menu-drawer__menu-item'
  );

  // Force first item active by default
  const firstSummary = topSummaries[0];
  if (firstSummary) {
    firstSummary.classList.add('is-active');
    firstSummary.closest('details')?.setAttribute('open', '');
  }

  topSummaries.forEach((summary) => {
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const clickedDetails = summary.closest('details');

      // 👉 If already active & open, do nothing
      if (
        summary.classList.contains('is-active') &&
        clickedDetails.hasAttribute('open')
      ) {
        return;
      }

      // Close all sibling details
      topSummaries.forEach((item) => {
        const details = item.closest('details');
        if (details !== clickedDetails) {
          item.classList.remove('is-active');
          details.removeAttribute('open');
        }
      });

      // Open clicked one
      clickedDetails.setAttribute('open', '');
      summary.classList.add('is-active');
    });
  });

  /**
   * CHILD & GRANDCHILD
   */
  const nestedSummaries = drawer.querySelectorAll(
    '.menu-drawer__submenu summary.menu-drawer__menu-item'
  );

  nestedSummaries.forEach((summary) => {
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const details = summary.closest('details');

      // 👉 If already active & open, do nothing
      if (
        summary.classList.contains('is-active') &&
        details.hasAttribute('open')
      ) {
        return;
      }

      const siblings = details
        .closest('ul')
        .querySelectorAll(':scope > li > details');

      // Close all sibling details
      siblings.forEach((sibling) => {
        if (sibling !== details) {
          sibling.removeAttribute('open');
          const sibSummary = sibling.querySelector('summary');
          if (sibSummary) sibSummary.classList.remove('is-active');
        }
      });

      // Open clicked one
      details.setAttribute('open', '');
      summary.classList.add('is-active');

      // Keep parent active
      const parentSummary =
        details
          .closest('.menu-drawer__submenu')
          ?.closest('details')
          ?.querySelector('summary');

      if (parentSummary) parentSummary.classList.add('is-active');
    });
  });

  /**
   * PREVENT BLANK CLICK RESET
   */
  drawer.addEventListener('click', (e) => {
    if (!e.target.closest('summary.menu-drawer__menu-item')) {
      e.stopPropagation();
    }
  });
});



// document.addEventListener("DOMContentLoaded", () => {
//   const tabs = document.querySelectorAll(".cus-collection-tab");

//   tabs.forEach(tab => {
//     tab.addEventListener("click", () => {
//       tabs.forEach(t => t.classList.remove("active"));
//       tab.classList.add("active");

//       // yahan se aap apna existing collection logic call kar sakte ho
//       console.log("Selected:", tab.dataset.collection);
//     });
//   });
// });

const tabs = document.querySelectorAll('.cus-collection-tab');

tabs.forEach(tab => {
  tab.addEventListener('click', function() {
    // Remove 'active' from all tabs
    tabs.forEach(t => t.classList.remove('active'));
    // Add 'active' to the clicked tab
    this.classList.add('active');
    // No e.preventDefault(), so link works normally
  });
});





document.addEventListener('click', function (e) {
  const btn = e.target.closest('.load-more-btn');
  if (!btn) return;

  e.preventDefault();

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  btn.classList.add('loading');
  btn.textContent = 'Loading...';

  fetch(nextUrl)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      const productGrid = document.querySelector('#product-grid');

      newProducts.forEach(item => {
        productGrid.appendChild(item);
      });

      const newBtn = doc.querySelector('.load-more-btn');

      if (newBtn) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.textContent = 'Load More';
        btn.classList.remove('loading');
      } else {
        btn.remove(); // last page
      }
    });
});

//  Custom js
(function($) {
  $(document).ready(function() {
    var isDrawerOpen = false;
    var hoverTimeout = null;
    var closeTimeout = null;
    
    // When hovering over menu items with data-drawer-menu-triger
    $('[data-drawer-menu-triger]').on('mouseenter', function() {
      // Clear any pending close timeout
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      var triggerValue = $(this).attr('data-drawer-menu-triger');
      
      // If drawer is not open, open it
      if (!isDrawerOpen) {
        $('.header__drawer--menu').click();
        isDrawerOpen = true;
      }
      
      // Find and click the matching data-menu-triger element
      hoverTimeout = setTimeout(function() {
        var $matchingTrigger = $('[data-menu-triger="' + triggerValue + '"]');
        if ($matchingTrigger.length && !$matchingTrigger.hasClass('is-active')) {
          $matchingTrigger.click();
        }
      }, 50); // Small delay to ensure drawer is open
    });
    
    // NEW: When hovering over header menu items, check if drawer should stay open
    $('.header__menu-item').on('mouseenter', function() {
      // Clear any pending close timeout
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      // Only check if drawer is currently open
      if (!isDrawerOpen) {
        return;
      }
      
      var $this = $(this);
      
      // Check if this menu item has data-drawer-menu-triger
      if (!$this.attr('data-drawer-menu-triger')) {
        // No data-drawer-menu-triger attribute, close the drawer
        closeDrawer();
        return;
      }
      
      // Has data-drawer-menu-triger, check if matching trigger exists
      var triggerValue = $this.attr('data-drawer-menu-triger');
      var $matchingTrigger = $('[data-menu-triger="' + triggerValue + '"]');
      
      if (!$matchingTrigger.length) {
        // No matching data-menu-triger found, close the drawer
        closeDrawer();
        return;
      }
      
      // Match found, activate the matching submenu
      if (!$matchingTrigger.hasClass('is-active')) {
        $matchingTrigger.click();
      }
    });
    
    // Function to close drawer
    function closeDrawer() {
      if (isDrawerOpen) {
        $('.header__drawer--menu').click();
        isDrawerOpen = false;
      }
    }
    
    // Keep drawer open when hovering over the drawer itself
    $(document).on('mouseenter', '.categories-menu, #menu-drawer, .menu-drawer-container', function() {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    });
    
    // Handle clicking on menu triggers inside drawer
    $(document).on('click', '[data-menu-triger]', function() {
      // Remove is-active from all triggers
      $('[data-menu-triger]').removeClass('is-active');
      // Add is-active to clicked trigger
      $(this).addClass('is-active');
    });
    
    // Close drawer when mouse leaves both categories-menu and drawer
    $('[data-drawer-menu-triger]').on('mouseleave', function() {
      closeTimeout = setTimeout(function() {
        checkAndCloseDrawer();
      }, 150);
    });
    
    $(document).on('mouseleave', '.categories-menu', function(e) {
      // Check if we're moving to the drawer
      var toElement = e.relatedTarget || e.toElement;
      if (!$(toElement).closest('#menu-drawer, .menu-drawer-container, header-drawer').length) {
        closeTimeout = setTimeout(function() {
          checkAndCloseDrawer();
        }, 150);
      }
    });
    
    $(document).on('mouseleave', '#menu-drawer, .menu-drawer-container, header-drawer', function(e) {
      // Check if we're moving to categories-menu
      var toElement = e.relatedTarget || e.toElement;
      if (!$(toElement).closest('.categories-menu, #menu-drawer, .menu-drawer-container, header-drawer').length) {
        closeTimeout = setTimeout(function() {
          checkAndCloseDrawer();
        }, 150);
      }
    });
    
    function checkAndCloseDrawer() {
      // Check if mouse is not over categories-menu or drawer
      if (isDrawerOpen) {
        var $hovered = $('.categories-menu:hover, #menu-drawer:hover, .menu-drawer-container:hover, header-drawer:hover');
        if ($hovered.length === 0) {
          closeDrawer();
        }
      }
    }
    
    // Track drawer state changes from manual interactions
    $(document).on('click', '.header__drawer--menu', function() {
      // Toggle state - drawer will be toggled by Shopify's native code
      setTimeout(function() {
        isDrawerOpen = $('#Details-menu-drawer-container').attr('open') !== undefined;
      }, 50);
    });
    
    // Update isDrawerOpen when drawer state changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          isDrawerOpen = $('#Details-menu-drawer-container').attr('open') !== undefined;
        }
      });
    });
    
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      observer.observe(drawerDetails, { attributes: true });
    }
  });
})(jQuery);


// SEARCH DRAWER LITTLE BIT JS
$(".search-drawer-button").click(function(){
  $(this).parents('.header-search-drawer-wrapper').addClass('open-drawer');
});

$(".header-search-drawer-body button.drawer_close__button").click(function(){
  $(this).parents('.header-search-drawer-wrapper').removeClass('open-drawer');
});
$(".header-search-drawer-overlay").click(function(){
  $(this).parents('.header-search-drawer-wrapper').removeClass('open-drawer');
});


$(document).on("click", ".product-option__notify-me", function() {
  $('.restock-rocket-button-cover').click()
});